<template>
  <WdsInput
    v-model="model"
    class="tw-min-w-[320px]"
    type="text"
    prefix-icon="search"
    :placeholder="$t('Search reviewer, requester, type...')"
  >
    <WdsIcon
      v-if="model"
      :size="16"
      class="tw-cursor-pointer tw-text-gray-500"
      name="close-filled"
    />
  </WdsInput>
</template>

<script setup lang="ts">
import { WdsInput, WdsIcon } from '@worksome/wds-components'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'

const model = defineModel<string>()
</script>
